import { useEffect } from "react";
import * as yup from "yup";
import {useFormik} from "formik";
import {Modal, Container, Row, Col, Form, Button} from "react-bootstrap";
import { Form as UiForm } from "@pdfme/ui";

export default function DataInputDialog({
  ui, show, onClose
}: {
  ui: UiForm | null,
  show: boolean,
  onClose: () => void,
}) {
  const f = useFormik({
    initialValues: {
    },
    validationSchema: yup.object().shape({
    }),
    onSubmit: async (values) => {
      if (ui) {
        ui.setInputs([values]);
        onClose();
      }
    }
  });


  useEffect(() => {
    const inputs = ui?.getInputs();
    if (inputs && typeof inputs[0] === 'object') {
      f.setValues(inputs[0]);
    }
  }, [show]);


  const generateFormFields = (f: any) => {
    if (!f.values) {
      return null;
    }

    return (
      Object.keys(f.values).map((key) => (
        <Row className="mb-2 d-flex align-items-center" key={key}>
          <Col>
            <Form.Label htmlFor={key}>{key}</Form.Label>
          </Col>
          <Col>
            <Form.Control id={key} type="text" as="textarea" name={key} value={f.values[key]} onChange={f.handleChange} />
          </Col>
        </Row>
      ))
    );
  }


  return (
    <Modal
      show={show}
      animation={false}
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>
          データ入力
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Container>
          {generateFormFields(f)}
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button onClick={() => f.handleSubmit()}>入力</Button>
      </Modal.Footer>
    </Modal>
  )
}
